// extracted by mini-css-extract-plugin
export default {"card-promo-host__skeleton--container":"styles_card-promo-host__skeleton--container__2NS8S","card-promo-host__skeleton":"styles_card-promo-host__skeleton__O4TLi"};